import {
  FETCH_PROTECTION_TIERS_REQUEST,
  FETCH_PROTECTION_TIERS_SUCCESS,
  FETCH_PROTECTION_TIERS_FAILURE,
  CREATE_PROTECTION_TIER_REQUEST,
  CREATE_PROTECTION_TIER_SUCCESS,
  CREATE_PROTECTION_TIER_FAILURE,
  UPDATE_PROTECTION_TIER_REQUEST,
  UPDATE_PROTECTION_TIER_SUCCESS,
  UPDATE_PROTECTION_TIER_FAILURE,
  DELETE_PROTECTION_TIER_REQUEST,
  DELETE_PROTECTION_TIER_SUCCESS,
  DELETE_PROTECTION_TIER_FAILURE,
} from "./types";

import {
  fetchProtectionTiers,
  createProtectionTier,
  updateProtectionTier,
  deleteProtectionTier,
} from "../../services/protectionTierService";



// Fetch
export const fetchProtectionTiersRequest = () => ({ type: FETCH_PROTECTION_TIERS_REQUEST });
export const fetchProtectionTiersSuccess = (data) => ({
  type: FETCH_PROTECTION_TIERS_SUCCESS,
  payload: data,
});
export const fetchProtectionTiersFailure = (error) => ({
  type: FETCH_PROTECTION_TIERS_FAILURE,
  payload: error,
});

// Create
export const createProtectionTierRequest = () => ({ type: CREATE_PROTECTION_TIER_REQUEST });
export const createProtectionTierSuccess = (data) => ({
  type: CREATE_PROTECTION_TIER_SUCCESS,
  payload: data,
});
export const createProtectionTierFailure = (error) => ({
  type: CREATE_PROTECTION_TIER_FAILURE,
  payload: error,
});

// Update
export const updateProtectionTierRequest = () => ({ type: UPDATE_PROTECTION_TIER_REQUEST });
export const updateProtectionTierSuccess = (data) => ({
  type: UPDATE_PROTECTION_TIER_SUCCESS,
  payload: data,
});
export const updateProtectionTierFailure = (error) => ({
  type: UPDATE_PROTECTION_TIER_FAILURE,
  payload: error,
});

// Delete
export const deleteProtectionTierRequest = () => ({ type: DELETE_PROTECTION_TIER_REQUEST });
export const deleteProtectionTierSuccess = (id) => ({
  type: DELETE_PROTECTION_TIER_SUCCESS,
  payload: id,
});
export const deleteProtectionTierFailure = (error) => ({
  type: DELETE_PROTECTION_TIER_FAILURE,
  payload: error,
});



// GET tiers
export const fetchProtectionTiersAction = () => async (dispatch) => {
  dispatch(fetchProtectionTiersRequest());
  try {
    const response = await fetchProtectionTiers();
    if (response.success) dispatch(fetchProtectionTiersSuccess(response.data));
    else dispatch(fetchProtectionTiersFailure(response.error));
    return response;
  } catch (error) {
    dispatch(fetchProtectionTiersFailure(error.message));
    return { success: false, error: error.message };
  }
};

// POST create tier
export const createProtectionTierAction = (data) => async (dispatch) => {
  dispatch(createProtectionTierRequest());
  try {
    const response = await createProtectionTier(data);
    if (response.success) dispatch(createProtectionTierSuccess(response.data));
    else dispatch(createProtectionTierFailure(response.error));
    return response;
  } catch (error) {
    dispatch(createProtectionTierFailure(error.message));
    return { success: false, error: error.message };
  }
};

// PUT update tier (uses tierId)
export const updateProtectionTierAction = (tierId, updates) => async (dispatch) => {
  dispatch(updateProtectionTierRequest());
  try {
    const response = await updateProtectionTier(tierId, updates);
    if (response.success) dispatch(updateProtectionTierSuccess(response.data));
    else dispatch(updateProtectionTierFailure(response.error));
    return response;
  } catch (error) {
    dispatch(updateProtectionTierFailure(error.message));
    return { success: false, error: error.message };
  }
};

// DELETE tier (uses tierId)
export const deleteProtectionTierAction = (tierId) => async (dispatch) => {
  dispatch(deleteProtectionTierRequest());
  try {
    const response = await deleteProtectionTier(tierId);
    if (response.success) dispatch(deleteProtectionTierSuccess(tierId));
    else dispatch(deleteProtectionTierFailure(response.error));
    return response;
  } catch (error) {
    dispatch(deleteProtectionTierFailure(error.message));
    return { success: false, error: error.message };
  }
};